import type {NoopType, TimeFnType} from '../type';

type ClearFnType<TimerId = unknown> = (id: TimerId) => void;

interface QueueItem<Result, TimerId = unknown> {
    callbackFn: NoopType<Result>;
    timerId: TimerId;
}

const initQueue = <Result, TimerId = unknown>(clear: ClearFnType<TimerId>) => {
    const timersSet = new Map<NoopType<Result>, QueueItem<Result, TimerId>>();

    globalThis?.addEventListener?.('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            [...timersSet.values()].forEach(({callbackFn, timerId}) => {
                clear(timerId);
                callbackFn();
            });
        }
    });

    return timersSet;
};

/**
 * timersQueue
 */
export const timersQueue = <TimerId, Result>(
    timeFn: TimeFnType<TimerId>,
    clearFn: ClearFnType<TimerId>,
) => {
    const set = initQueue<Result, TimerId>(clearFn);

    return (callbackFn: NoopType<Result>, ms: number) => {
        const timerId = timeFn(() => {
            set.delete(callbackFn);
            callbackFn();
        }, ms);

        set.set(callbackFn, {
            callbackFn,
            timerId,
        });
    };
};
